import { ShieldCheck, Download, BadgeCheck } from "lucide-react";

const STATS = [
  { value: "80 000 €", label: "de couverture par déménagement" },
  { value: "6 000 000 €", label: "pour les dommages matériels et immatériels" },
  { value: "Franchise", label: "prise en charge par Big Déménagement selon conditions" },
];

export default function AssuranceSection() {
  return (
    <section
      id="assurance"
      data-testid="assurance-section"
      className="py-10 sm:py-14 bg-[#f7fafc] border-y border-[#e6edf3]"
    >
      <div className="bd-container">
        {/* Header */}
        <div className="max-w-3xl">
          <span className="bd-eyebrow">Notre assurance</span>
          <h2 className="bd-h2 mt-5 text-[26px] sm:text-[30px] lg:text-[36px]">
            Vos biens, <span style={{ color: "#237cb5" }}>protégés</span> à chaque étape.
          </h2>
          <p className="mt-6 text-[#3a4a5a] text-base leading-relaxed">
            Big Déménagement est assuré chez{" "}
            <strong className="text-[#0f1d2b]">Allianz</strong>, l'un des leaders mondiaux de
            l'assurance. Notre contrat professionnel couvre la prestation de déménagement et vos
            biens, de la préparation jusqu'à la livraison.
          </p>
        </div>

        {/* Insurance panel — white bg with blue accents */}
        <div
          data-testid="assurance-panel"
          className="mt-12 relative rounded-3xl overflow-hidden p-8 sm:p-10 lg:p-12 bg-white border border-[#e6edf3] shadow-[0_30px_60px_-30px_rgba(35,124,181,0.25)]"
        >
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {/* Allianz badge + CTA */}
            <div className="lg:col-span-5">
              <div className="flex items-center gap-2 text-[11px] font-bold tracking-[0.22em] uppercase text-[#237cb5]">
                <ShieldCheck className="h-3.5 w-3.5" />
                Assurance professionnelle
              </div>

              <div className="mt-4 inline-flex items-center gap-3 rounded-xl bg-[#eaf3fb] border border-[#cfe1f3] px-4 py-3">
                <img
                  src="/images/allianz-logo.webp"
                  alt="Logo Allianz — assurance dommages déménagement de Big Déménagement"
                  width="120"
                  height="32"
                  loading="lazy"
                  decoding="async"
                  className="h-8 w-auto object-contain"
                />
                <div className="leading-tight">
                  <div className="text-[10px] uppercase tracking-[0.18em] text-[#5b6b7a]">
                    Notre assureur
                  </div>
                  <div className="text-base font-extrabold tracking-tight text-[#0f1d2b]">
                    Allianz
                  </div>
                </div>
              </div>

              <p className="mt-5 text-[#3a4a5a] text-sm leading-relaxed">
                Sur simple demande, nous vous transmettons notre attestation d'assurance
                professionnelle pour votre tranquillité.
              </p>

              <a
                href="/attestation-assurance-big-demenagement.pdf"
                download
                data-testid="assurance-download-cta"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#237cb5] hover:bg-[#1c6699] text-white font-bold h-11 px-5 text-sm transition-colors shadow-[0_14px_24px_-12px_rgba(35,124,181,0.6)]"
              >
                <Download className="h-4 w-4" />
                Télécharger l'attestation
              </a>
            </div>

            {/* Stats — blue cards (Hero form blue) */}
            <ul className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6">
              {STATS.map((s, i) => (
                <li
                  key={s.label}
                  data-testid={`guarantee-${i}`}
                  className="rounded-xl bg-[#4285F4] border border-[#3776e0] px-4 py-3.5 sm:px-5 sm:py-5 shadow-[0_18px_30px_-18px_rgba(66,133,244,0.55)]"
                >
                  <div className="flex items-center gap-2.5 sm:block">
                    <BadgeCheck className="h-4 w-4 sm:h-5 sm:w-5 text-white/90 shrink-0" aria-hidden="true" />
                    <div className="sm:mt-3 text-lg sm:text-[26px] font-extrabold leading-none tracking-tight text-white">
                      {s.value}
                    </div>
                  </div>
                  <div className="mt-1.5 sm:mt-2 text-[12px] sm:text-[13px] leading-snug text-white/85">
                    {s.label}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
